/* LogFoldingRules.js */

define(function (require, exports) {
    const oop = ace.require("ace/lib/oop");
    const Range = ace.require("ace/range").Range;
    const BaseFoldMode = ace.require("ace/mode/folding/fold_mode").FoldMode;

    const GluLogFoldMode = (exports.GluLogFoldMode = function () {});
    oop.inherits(GluLogFoldMode, BaseFoldMode);

    (function () {
        this.foldingStartMarker = /(\s)*>>/;

        this.getFoldWidget = function (session, foldStyle, row) {
            let line = session.getLine(row);
            let taskMatch = line.match(this.foldingStartMarker);
            if (taskMatch && taskMatch.index === 0) {
                return "start";
            }
            return "";
        };

        this.getFoldWidgetRange = function (session, foldStyle, row) {
            let logMsg = session.getLine(row);
            let taskMatch = logMsg.match(this.foldingStartMarker);
            if (taskMatch && taskMatch.index === 0) {
                let foldEndLogMsg = logMsg.replace(">>", "<<");
                let endOfTaskFound = false,
                    foldEndRowIndex = row + 1;
                while (!endOfTaskFound && foldEndRowIndex < session.getLength()) {
                    let currentLine = session.getLine(foldEndRowIndex);
                    endOfTaskFound = foldEndLogMsg === currentLine;
                    if (!endOfTaskFound) {
                        foldEndRowIndex++;
                    }
                }
                return new Range(row, logMsg.length, foldEndRowIndex, foldEndLogMsg.length);
            }
            return null;
        };
    }).call(GluLogFoldMode.prototype);
});
